class AppHeaderController {
    constructor(AppUserService, $state) {
        'ngInject';
        this.AppUserService = AppUserService;
        this.$state = $state;
    }

    logOut() {
        this.AppUserService.logOutUser()
            .then(() => {
                this.$state.go("pages.index")
            });
    }
}

export const AppHeaderComponent = {
    name: 'appHeader',
    component: {
        template: `
            <img class="img-responsive" src="/app/img/welcome-mms-plus-ko.png" alt="MyMedSchedule Plus">
            <span ng-click="$ctrl.logOut()">Log out</span>
        `,
        controller: AppHeaderController,
        bindings: {
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/appHeader.component.js